import DownIcon from 'components/PWAprompt/Down'
import PlayIcon from 'components/ReusableComponents/Icons/Play'
import YouTubeDialog from 'components/ReusableComponents/YouTubeDialog'
import { useState } from 'react'

import styles from './PWAprompt.module.scss'

const PWAprompt = ({ showPWAprompt, deferredPrompt, handleClick }) => {
  const [isYouTubeVideoVisible, setIsYouTubeVideoVisible] = useState(false)

  function handleInstallClick() {
    deferredPrompt.prompt()
    deferredPrompt.userChoice.then(choiceResult => {
      if (choiceResult.outcome === 'accepted') {
        handleClick()
      }
    })
  }

  if (showPWAprompt) {
    return (
      <>
        {isYouTubeVideoVisible && (
          <YouTubeDialog
            videoId="R_lJ3lIJgzw"
            onClose={() => setIsYouTubeVideoVisible(false)}
          />
        )}
        <div className={styles.wrapper}>
          <div className={styles.container} onClick={handleInstallClick}>
            <div className={styles.content}>
              <div className={styles.messages}>
                <div className={styles.title}>Directful desktop app</div>
                <div className={styles.description}>
                  Use the Dashboard from your desktop
                </div>
              </div>
            </div>
            <button>
              <DownIcon />
              Install
            </button>
          </div>
          <button
            className={styles.watchLink}
            onClick={() => setIsYouTubeVideoVisible(true)}
          >
            <PlayIcon />
            Watch video with instructions
          </button>
        </div>
      </>
    )
  }

  return null
}

export default PWAprompt
